import type { StatusTone } from '@/components/shell/StatusChip';
import type { CredentialStatus } from '@/api/models';

/** Maps an API credential's status to one of the theme's five badge tones (foundations.md §7.8). */
export function credentialStatusTone(status: CredentialStatus): StatusTone {
  return status === 'active' ? 'success' : 'neutral';
}
